import React, { useEffect, useContext, useState, useReducer } from "react";
import { makeStyles, Grid, Typography, Button, Collapse, RootRef, IconButton, useMediaQuery, useTheme } from "@material-ui/core";
import SortIcon from "@material-ui/icons/Sort";
import { useLocation, useHistory } from "react-router-dom";
import { AuthContext } from "../context";
import { TextField, ProductCard, Paper, Loader, PopUp, PaperOptions, Popover } from "../components";
import { SearchIcon, GridIcon, RecordIcon, ArrowBackIcon } from "../icons";
import { labServices } from "../services";
import { modals } from "../constants";
import { useScroll, useResize, usePopover } from "../hooks";

export default function LabScreen(props) {
  const location = useLocation();
  const [viewList, setViewList] = useState(true);
  const { domRef, paperGrow, onScroll } = useScroll(100);
  const [imageLoaded, setImageLoaded] = useState(false);
  const { collapseH } = useResize(imageLoaded);
  const classes = useStyles({ lab: location.state.lab, viewList, paperGrow, collapseH, ...props })();
  const [query, setQuery] = useState("");
  const [loading, setLoading] = useState(false);
  const [modal, setModal] = useState(false);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [filter, setFilter] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [changeSize, setChangeSize] = useState(false);
  const { authState, signOut } = useContext(AuthContext);
  const history = useHistory();
  const matchesDesktop = useMediaQuery(useTheme().breakpoints.up("md"));
  const { id, open, anchorEl, setAnchorEl } = usePopover();

  const [products, dispatch] = useReducer((myArray, { type, value }) => {
    switch (type) {
      case "add":
        return [...myArray, value];
      case "remove":
        return myArray.filter((_, index) => index !== value);
      case "updateIsSelect":
        return myArray.map((element, index) => {
          if (index === value) {
            return {
              ...element,
              isSelect: !element.isSelect,
            };
          }
          return { ...element };
        });
      case "orderBy":
        return myArray.sort(function (a, b) {
          if (a[value].toLowerCase() > b[value].toLowerCase()) {
            return 1;
          }
          if (a[value].toLowerCase() < b[value].toLowerCase()) {
            return -1;
          }
          // a must be equal to b
          return 0;
        });
      default:
        return myArray;
    }
  }, []);

  useEffect(() => {
    async function init() {
      if (location.state) {
        try {
          setLoading(true);
          const { status, response } = await labServices.getProductsFromLab({ token: authState.token, LAB_ID: location.state.lab._id, doctorId: authState.user.doctor._id });
          setLoading(false);
          if (status === 200) {
            const orderArray = response.products.sort(function (a, b) {
              if (a.name.toLowerCase() > b.name.toLowerCase()) {
                return 1;
              }
              if (a.name.toLowerCase() < b.name.toLowerCase()) {
                return -1;
              }
              // a must be equal to b
              return 0;
            });
            orderArray.forEach((element, index) => {
              dispatch({
                type: "add",
                value: {
                  ...element,
                  isSelect: false,
                  quantityToAssign: 1,
                  index,
                },
              });
            });
          } else if (status === 401) {
            signOut();
          }
        } catch (e) {
          setLoading(false);
          console.log("Error", e);
        }
      }
    }
    init();
  }, [authState, location, signOut]);

  const updateIsSelect = async (index) => {
    dispatch({ type: "updateIsSelect", value: index });
  };

  const filterList = (value) => {
    if (value === "") {
      setFilter(false);
    }
    setQuery(value);
    setFilteredProducts(products.filter((element, index) => element.name.toLowerCase().includes(value.toLowerCase()) || element.molecule.toLowerCase().includes(value.toLowerCase())));
    setFilter(true);
  };

  const onSubmit = async () => {
    try {
      const productsSelect = products
        .filter((product) => product.isSelect)
        .map((element) => {
          return { _id: element._id };
        });
      setLoading(true);
      const { status, response } = await labServices.addOrder({ products: productsSelect, token: authState.user.token, doctorId: authState.user.doctor._id });
      setLoading(false);
      if (status === 201) {
        setModal(!modal);
        setModalMessage(response.message);
      } else if (status === 401) {
        signOut();
      } else {
        console.log({ error: true, status, response });
      }
    } catch (e) {
      setLoading(false);
      console.log("Error", e);
    }
  };

  const orderList = async (index) => {
    setAnchorEl(null);
    setLoading(true);
    await dispatch({ type: "orderBy", value: index === 0 ? "name" : index === 1 ? "molecule" : "assigned" });
    setLoading(false);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Grid container>
      <PopUp
        modalName={modals[2]}
        open={modal}
        setModal={() => setModal(!modal)}
        message={modalMessage}
        popToTop="/request"
        modalSubMessage={"Por favor debe estar atento de la confirmación de su pedido."}
      />
      {loading && <Loader loading={true} />}
      <Grid className={classes.container} container>
        <Collapse in={!matchesDesktop ? !paperGrow : true} timeout={500} style={{ width: "100%" }} id={"collapseId"}>
          <Grid className={classes.containerImage} container>
            <Grid item md={3} xs={6}>
              <img src="../../assets/laboratorio.svg" alt="" onLoad={() => setImageLoaded(true)} />
            </Grid>
            <Grid md={9} className={classes.desktopOptions} container justify="flex-start" alignItems="center" item>
              <Grid item md={2} lg={1}>
                <IconButton style={{ padding: 0 }} onClick={() => history.goBack()}>
                  <ArrowBackIcon />
                </IconButton>
              </Grid>
              <Grid item md={10} lg={11}>
                <Typography component="h1" variant="h1">
                  Laboratorio
                </Typography>
              </Grid>
              <Grid item md={12} style={{ margin: "20px 0 0 0" }}>
                <Grid container justify="space-between" alignItems="center">
                  <Grid item md={8} style={{ position: "relative" }}>
                    <TextField
                      type={"text"}
                      name={"query"}
                      value={query}
                      placeholder="¿Qué estás buscando?"
                      fontWeight="bold"
                      style={{ justifyContent: "flex-end" }}
                      showIcon
                      iconComponent={() => <SearchIcon />}
                      onClickIcon={() => {}}
                      onChange={(e) => filterList(e.target.value)}
                    />
                    <Grid item xs={12} md={12} className={classes.titleLabDesktop}>
                      <Grid container alignItems="center" className={classes.box}>
                        <div>
                          <Typography>{location.state.lab.name.charAt(0)}</Typography>
                        </div>
                        <div>
                          <Typography>Laboratorio</Typography>
                          <Typography>{location.state.lab.name}</Typography>
                        </div>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item md={4} container justify="flex-end">
                    <IconButton aria-describedby={id} onClick={handleClick} style={{ width: 45, height: 45 }}>
                      {" "}
                      <SortIcon style={{ color: "#2196C0" }} />{" "}
                    </IconButton>
                    <IconButton onClick={() => setViewList(true)} style={{ backgroundColor: viewList ? "#2196C0" : "unset", width: 45, height: 45 }}>
                      {" "}
                      <RecordIcon color={viewList ? "white" : "#2196C0"} />{" "}
                    </IconButton>
                    <IconButton onClick={() => setViewList(false)} style={{ backgroundColor: viewList ? "unset" : "#2196C0", width: 45, height: 45 }}>
                      {" "}
                      <GridIcon color={viewList ? "#2196C0" : "white"} />{" "}
                    </IconButton>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          {/*<Grid container justify="center" alignItems="center" style={{padding:"5px 25px 9px 45px"}}>
            <img src="../../assets/laboratorio.svg" alt=""  />
          </Grid>*/}
        </Collapse>
        <Paper className={classes.paperClass}>
          <PaperOptions
            title={"Muestras"}
            query={query}
            changeSize={changeSize}
            setChangeSize={(value) => setChangeSize(value)}
            viewList={viewList}
            setViewList={(value) => setViewList(value)}
            filterList={(e) => filterList(e)}
            orderList={(index) => orderList(index)}
            handleClickPopover={(event) => handleClick(event)}
          />
          <Popover id={id} open={open} anchorEl={anchorEl} handleClose={handleClose} orderList={(index) => orderList(index)} />
          <Grid item xs={12} md={12} className={classes.titleLab}>
            <Grid container alignItems="center" className={classes.box}>
              <div>
                <Typography>{location.state.lab.name.charAt(0)}</Typography>
              </div>
              <div>
                <Typography>Laboratorio</Typography>
                <Typography>{location.state.lab.name}</Typography>
              </div>
            </Grid>
          </Grid>
          {/*<Grid container className={classes.desktopOptions}>
            <Grid container justify="flex-start" alignItems="center" item md={4} xs={4}>
              <Typography component="h1" variant="h1" align="center">Muestras</Typography>
            </Grid>
            <Grid container justify="flex-end" item md={8} xs={8}>
              <TextField 
                  type={"text"}
                  name={"query"}
                  value={query}
                  placeholder="¿Qué estás buscando?"
                  fontWeight="bold"
                  style={{justifyContent:"flex-end"}}
                  showIcon
                  iconComponent={() => <SearchIcon />}
                  onClickIcon={() => {}}
                  onChange={(e) => filterList(e.target.value)}
                />
            </Grid>
            
        </Grid>*/}
          <RootRef rootRef={domRef}>
            <Grid container spacing={2} className={classes.scrollList} onScroll={onScroll}>
              {!filter &&
                products.map((product, index) => (
                  <Grid item md={viewList ? 12 : 3} xs={viewList ? 12 : 6} key={index} style={{ marginBottom: products.length - 1 === index ? 50 : 0 }}>
                    <ProductCard viewList={viewList} product={product} hideQuantity onClickSelect={() => updateIsSelect(index)} />
                  </Grid>
                ))}
              {filter &&
                filteredProducts.map((product, index) => (
                  <Grid item md={viewList ? 12 : 3} xs={viewList ? 12 : 6} key={index} style={{ marginBottom: products.length - 1 === index ? 50 : 0 }}>
                    <ProductCard product={product} hideQuantity onClickSelect={() => updateIsSelect(product.index)} />
                  </Grid>
                ))}
            </Grid>
          </RootRef>
        </Paper>
      </Grid>
      {products.some((element) => element.isSelect) && (
        <Grid container className={classes.containerBtn}>
          <Button onClick={onSubmit} fullWidth className={classes.btn}>
            SOLICITAR MUESTRAS
          </Button>
        </Grid>
      )}
    </Grid>
  );
}

const useStyles = ({ lab, viewList, paperGrow, collapseH, ...props }) =>
  makeStyles((theme) => ({
    container: {
      display: "block",
      height: "100%",
      [theme.breakpoints.up("md")]: {
        padding: "50px 50px 0 50px",
      },
    },
    containerBtn: {
      position: "fixed",
      bottom: 90,
      padding: "0 12px",
      zIndex: 3,
      "& button": {
        backgroundColor: theme.palette.secondary.main,
        color: "#FFF",
        height: 41,
        borderRadius: 20.5,
        fontSize: "1.125rem",
        lineHeight: "1.375rem",
        fontWeight: "bold",
        "&:hover": {
          backgroundColor: theme.palette.secondary.main,
        },
      },
    },
    titleLab: {
      [theme.breakpoints.up("md")]: {
        display: "none",
      },
    },
    titleLabDesktop: {
      [theme.breakpoints.down("sm")]: {
        display: "none",
      },
    },
    containerImage: {
      justifyContent: "center",
      [theme.breakpoints.up("md")]: {
        justifyContent: "flex-start",
        margin: "0 0 50px 0",
      },
      "& > div:nth-child(1)": {
        padding: "10px 0",
        [theme.breakpoints.up("md")]: {
          padding: 0,
        },
        "& img": {
          [theme.breakpoints.up("md")]: {
            width: "100%",
          },
        },
      },
      "& > div:nth-child(2)": {
        [theme.breakpoints.up("md")]: {
          padding: "0 0 0 40px",
        },
      },
    },
    paperClass: {
      height: paperGrow ? "100%" : "calc(100% - 130px)",
      [theme.breakpoints.up("md")]: {
        height: `calc(100% - ${collapseH}px)`,
      },
    },
    scrollList: {
      height: "calc(100% - 170.66px)",
      overflowY: "scroll",
      [theme.breakpoints.up("md")]: {
        height: "98%",
      },
      [theme.breakpoints.down("sm")]: {
        "&::-webkit-scrollbar": {
          width: "1px",
        },
        "&::-webkit-scrollbar-thumb": {
          backgroundColor: "rgba(0,0,0, .1)",
        },
      },
      display: viewList ? "block" : "flex",
      paddingTop: 0,
      width: "100%",
      margin: 0,
      "&::-webkit-scrollbar": {
        width: "4px",
        height: "8px",
      },
      "&::-webkit-scrollbar-track": {
        boxShadow: "inset 0 0 6px rgba(0,0,0,0.00)",
        webkitBoxShadow: "inset 0 0 6px rgba(0,0,0,0.00)",
      },
      "&::-webkit-scrollbar-thumb": {
        backgroundColor: theme.palette.secondary.main,
        borderRadius: "10px",
      },
    },
    desktopOptions: {
      [theme.breakpoints.down("sm")]: {
        display: "none",
      },
    },
    box: {
      background: "#FFFFFF",
      borderRadius: 22,
      width: "100%",
      height: 85,
      padding: "13px 13px 13px 0",
      "& div:nth-child(1)": {
        width: "16%",
        height: 50,
        borderRadius: 15,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: lab.color,
        "& p": {
          fontSize: "2rem",
          color: "#FFF",
          fontWeight: "bold",
        },
      },
      "& div:nth-child(2)": {
        width: "74%",
        padding: "5.5px 0 10px 15px",
        boxSizing: "border-box",
        "& p:nth-child(1)": {
          fontSize: "0.813rem",
          lineHeight: "1rem",
          color: theme.palette.secondary.main,
          fontWeight: "bold",
        },
        "& p:nth-child(2)": {
          margin: "2px 0 0 0",
          fontSize: "0.875rem",
          lineHeight: "1.063rem",
          color: theme.palette.primary.main,
          fontWeight: "500",
        },
        "& div": {
          height: "fit-content",
        },
        "& img": {
          objectFit: "contain",
        },
      },
    },
  }));
